import React from 'react';

const ArticleCard = ({ post, source, sanitizeText, formatDate }) => (
  <article className="blog-post bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
    <a
      href={post.link}
      target="_blank"
      rel="noopener noreferrer"
      className="post-link block hover:bg-gray-50 transition-colors"
      aria-label={`${source}記事: ${sanitizeText(post.title)}`}
    >
      <div className="p-6">
        {post.thumbnail && (
          <figure className="post-thumbnail mb-4 aspect-video overflow-hidden rounded-lg">
            <img
              src={post.thumbnail}
              alt={`${sanitizeText(post.title)}のサムネイル画像`}
              className="w-full h-full object-cover"
              loading="lazy"
              width="320"
              height="180"
            />
          </figure>
        )}
        <h4 className="post-title text-lg font-semibold text-gray-800 mb-2">
          {sanitizeText(post.title)}
        </h4>
        {post.description && (
          <p className="post-description text-gray-600 mb-2 text-sm">
            {sanitizeText(post.description)}
          </p>
        )}
        <time className="post-date flex items-center text-sm text-gray-500" dateTime={post.date}>
          <span>{formatDate(post.date)}</span>
        </time>
      </div>
    </a>
  </article>
);

export default ArticleCard;